import { render } from "./GoogleSso.vue?vue&type=template&id=788eacee"
import script from "./GoogleSso.vue?vue&type=script&lang=js"
export * from "./GoogleSso.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__